import { request } from './http'

export interface ReadyzResponse {
  status: string
  [key: string]: unknown
}

export const healthApi = {
  ready: (): Promise<ReadyzResponse> => request<ReadyzResponse>('/readyz'),
}
